// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"7225":"layout","8837":"Workbench"}[chunkId] || chunkId) + "." + {"3382":"c4348105","3631":"b6cc01b3","6564":"9bac9bea","7225":"c1c634ae","7760":"599d404c","8837":"496760a1","8893":"4ff0cde1"}[chunkId] + ".css";
};